import styles from './TermConditionPage.module.scss';
import Label from '../../../../constants/Label';
import React, { useEffect, useState } from 'react';
import SideBanner from '../../components/side-banner/SideBanner';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import { Link, useHistory, useLocation } from 'react-router-dom';

function TermConditionPage() {
  const history = useHistory();
  const location = useLocation();
  const [checked, setChecked] = React.useState(false);
  // setData((data) => ({ ...data, errorMsg: '' }));
  const [data, setData] = useState({
    errorMsg: '',
  });
  const handleSubmit = () => {
    localStorage.setItem('term', true);
    if (checked == false) {
      setData((data) => ({ ...data, errorMsg: 'Please agree to terms & conditions ' }));
      return;
    } else {
      history.push({ pathname: '/', state: { ...location.state } });
    }
  };

  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <div className={styles.LoginPage__artwork}>
          <SideBanner />
        </div>
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.TermsandCondition.heading}</h1>
          <div className={styles.LoginPage__terms}>
            {/* <p>1) Introduction</p> */}
            <p>
              1) In order to use this Service, you must be:
              <br />
              a) A Resident in Kuwait holding valid Civil ID card <br />
              b) Accept this Terms and condition and get registered by us as a user
              <br />
              <br />
              The Kuwait India International Exchange Company (KIIEC) reserves the right to refuse access to this
              <br />
              Service and may, at any time and at its sole discretion, cancel all your rights and privileges relating to the Service, without
              assigning any reason to you.
            </p>
            <p>
              <b>ACCESS ENVIRONMENT:</b> You should take all reasonably practicable measures to ensure the security <br />
              while accessing our site on-line. You must not leave your System unattended; should sign off after every
              <br />
              session. You are responsible for complying with all applicable laws while accessing our service. You will
              <br />
              undertake not to divulge your login credentials to anyone else.
            </p>
            <p>
              <b>MAINTAINING SESSION SECURITY:</b> You are solely responsible at all times for the secrecy of your <br />
              password and other access codes, including your secret number. You must not allow anyone else to
              <br />
              operate the Service on your behalf. Never disclose your password or secret PIN number in your email or
              <br />
              phone communication. We will never ask you to do so.
            </p>
            <p>
              <b>USER IDENTIFICATION:</b> Security codes for access (namely your login, password, otp, mpin etc) will be <br />
              the basis on which you will be identified and instructions given using them may be acted upon by KIIEC
              <br />
              without obtaining any further written confirmation from you.
              <br />
            </p>
            <p>
              <b>PRIVACY:</b> KIIEC will exercise all reasonable efforts to ensure that information pertaining to you is not <br />
              made available to third parties unless it is (a) authorised by you or (b) required under law or (c) to protect
              <br />
              the interest of KIIEC.
              <br />
            </p>
            <p>
              <b>SOURCE OF MONEY:</b> By agreeing to utilise the services, you undertake and confirm that you are the <br />
              lawful owner of the monies being remitted to the beneficiary and have the capacity and authority to
              <br />
              execute this remittance. You also undertake and declare that you have full and complete knowledge of
              <br />
              the beneficiary and that the monies are being remitted for personal and lawful purposes.
            </p>
            <p>
              <b>AML COMPLIANCE:</b> The services are provided subject to the remittance meeting requirements under <br />
              AML(Anti Money Laundering)/CFT(Combating Financing of Terrorism)/Anit-Fraud/Consumer Protection/
              <br />
              KYC (Know Your Customer) regulations. One or more remittances may be refused or withheld from
              <br />
              execution at the sole discretion of the Company for want of any requirements under
              <br />
              AML/CFT/Anit-Fraud/Consumer Protection/ KYC guidelines. The Company also reserves right not to
              <br />
              process your request in case of payments using third party cards.
            </p>
            <p>
              <b>USE OF MESSAGING SERVICE:</b> KIIEC is not responsible for the timeliness of delivery of or responding <br />
              to Email / SMS messages through KIRAN, even though the same will be attempted promptly.
            </p>
            <p>
              <b>CHARGES:</b> KIIEC is entitled to charge you service fees/commission for one or more features of the <br />
              service provided by us or change those service fees/commission from time to time.
            </p>

            <p>
              <b>PROCESSING OF TRANSFER REQUESTS SUBMITTED TO KIIEC THROUGH THIS SERVICE:</b>
              <br />
              <br />
              * The transfer requests will be processed by the KIIEC only after the KIIEC receives an independent and <br />
              clear confirmation that the amount there against has been received from you. <br />
              <br />
              * You are not entitled to give us instructions that are conditional. <br />
              <br />
              * Transactions entered after the cut-off time or on a non-business day may be processed only on the next <br />
              business day, even though the service may be operational on all days and beyond normal working hours.
              <br />
              <br />
              * Once submitted, modifications of any of the details of the transfer request, such as the rate of exchange, <br />
              charges, amount of remittance, currency of remittance, total amount payable to KIIEC against the <br />
              remittance etc. is not possible. <br />
              <br />
              * You are solely responsible for the accuracy and correctness of all of your instructions you have filled in <br />
              under this service.
              <br />
              <br />
              * KIIEC is not responsible for securing a response/ advice/receipt/confirmation etc. for the remittances <br />
              from the destination country/entity. <br />
              <br />
              * The beneficiary bank/intermediate bank may deduct or apply its own charges which will be in addition to <br />
              the charges payable to KIIEC. <br />
              <br />
              * The internal records of the KIIEC shall be conclusive evidence of all transactions as between the KIIEC <br />
              and Client. <br />
              <br />
              * Remittances sent using mobile App is also subject to the other standard terms and conditions applicable <br />
              for normal remittances. <br />
              <br />
              * Cancellations of remittance made under this service cannot be effected until KIIEC has received definite <br />
              advice(s) from their correspondents that the remittance is unpaid and that the original instructions have <br />
              been cancelled. <br />
              <br />
            </p>
            <p>
              <b>RESTRICTION OF LIABILITY OF KIIEC:</b> <br />
              <br />
              <p>
                The KIIEC reserves its right without incurring any liability whatsoever to refuse to process any of the Customer's transactions given
                via the Service.{' '}
              </p>
              <p>The KIIEC will make all reasonable efforts to advise the Customer of such instances but is not obligated to do so.</p>
              <p>
                KIIEC will not be liable for any loss of capital or interest or any damages, whether direct or indirect, arising out of the loss or
                delay or error in handling the remittances, either by KIIEC or by any of its correspondents or agents.
              </p>
              <p>
                Under no circumstance will KIIEC be liable for any damages, including without limitation direct or indirect, special, incidental, or
                consequential damages, losses or expenses or lost profits, lost opportunity or any indirect, consequential, incidental, special,
                punitive, or exemplary damages arising in connection with this service or any linked web site or use thereof or inability to use by
                any party, or in connection with any technical malfunction or failure of performance, error, omission, interruption, defect, delay in
                operation or transmission, computer virus or line or system failure.
              </p>
              <p>
                KIIEC shall not be liable for any loss/damage or delays directly caused or arising out force Majeure, namely, riots, wars, lock outs
                and strikes, embargo, confiscations, acts of God such as fire, flood, earthquake etc.,
              </p>
            </p>

            <p>
              <b>AMENDMENTS TO TERMS AND CONDITIONS:</b> KIIEC may make changes, additions or deletions to these Terms and Conditions or services or
              mode of services or charges or any terms and conditions supplemental to them.
            </p>
            <p>
              <b>JURISDICTION:</b> This agreement is governed by the laws of Kuwait. This does not affect our right to pursue our remedies in the
              courts of any other jurisdiction that is considered appropriate by us.
            </p>
          </div>
          <div className={styles.checkbox}>
            <input type="checkbox" id="term" name="todo" value="todo" checked={checked} onChange={() => setChecked(!checked)} />
            <label htmlFor="term">
              I have read and accept the <a>Terms & Conditions.</a>
            </label>
            {/* <Link className={styles.LoginPage__link}> */}
            <button className={styles.LoginPage__link} type="submit" onClick={handleSubmit}>
              {Label.TermsandCondition.buttonLabel}
            </button>
            {/* </Link> */}
          </div>
          {!checked ? <div className={styles.formgroup__error}>{data.errorMsg}</div> : ''}
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { TermConditionPage };
